const BUTTON_SIZE = 56;
const EDGE_MARGIN = 12;

/**
 * A dragged floating button's saved spot, kept inside the current window.
 * The spot is saved in pixels, so one saved on a wider or taller screen can sit
 * outside a smaller window and the button disappears (2026-09-29).
 *
 * @param {{left: number, top: number}|null} position saved spot, or null for the default corner
 * @param {{width: number, height: number}} viewport
 * @returns {{left: number, top: number}|null}
 */
export function keepInsideViewport(position, viewport, size = BUTTON_SIZE, margin = EDGE_MARGIN) {
  if (!position || !Number.isFinite(position.left) || !Number.isFinite(position.top)) return null;
  const maxLeft = Math.max(margin, viewport.width - size - margin);
  const maxTop = Math.max(margin, viewport.height - size - margin);
  const left = Math.min(Math.max(position.left, margin), maxLeft);
  const top = Math.min(Math.max(position.top, margin), maxTop);
  return left === position.left && top === position.top ? position : { left, top };
}
